import { FC } from "react";
import { Badge } from "@mantine/core";
import { TeamLogo } from "../../../../Components/TeamLogo";
import { TeamName } from "../../../../Components/TeamName";
import { ResolvedTeamReference } from "../../../../Components/ResolvedTeamReference";
import { Time } from "../../../../Components/Time";
import { getPresentationParamsForOrigin } from "../../../../getPresentationParamsForOrigin";
import { components } from "../../../../openapi/generated-types";

interface LiveGameCardProps {
  game: components["schemas"]["Game"];
  time: number;
  competitionId: string;
}

export const LiveGameCard: FC<LiveGameCardProps> = ({
  game,
  time,
  competitionId,
}) => {
  const brandColors = getPresentationParamsForOrigin().colors.brand;

  return (
    <div
      style={{
        backgroundColor: "rgb(30,30,30)",
        color: "white",
        fontSize: 56,
        padding: "30px",
        borderBottom: `5px solid ${brandColors[7]}`,
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "3fr 1fr 2fr 1fr 3fr",
          alignItems: "center",
          textAlign: "center",
          gap: "50px",
        }}
      >
        <div
          style={{
            textAlign: "right",
            textWrap: "pretty",
          }}
        >
          {game.actualTeams.homeTeamId ? (
            <TeamName variant="medium" teamId={game.actualTeams.homeTeamId} />
          ) : (
            <ResolvedTeamReference
              competitionId={competitionId}
              teamReference={game.plannedTeams.home}
            />
          )}
        </div>
        <div>
          <div style={{ width: "220px", marginLeft: "auto" }}>
            <TeamLogo height={220} teamId={game.actualTeams.homeTeamId} />
          </div>
        </div>
        <div style={{ fontFamily: "Chivo Mono", lineHeight: 1 }}>
          <div
            style={{
              fontSize: 48,
              color: brandColors[7],
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "15px",
            }}
          >
            <Time time={time} />
            {game.started && !game.result && <Badge size="lg">Live</Badge>}
          </div>
          <div style={{ fontSize: 180, fontWeight: "bold" }}>
            {game.score.home}:{game.score.guest}
          </div>
        </div>

        <div>
          <div style={{ width: "220px" }}>
            <TeamLogo height={220} teamId={game.actualTeams.guestTeamId} />
          </div>
        </div>
        <div
          style={{
            textAlign: "left",
            textWrap: "pretty",
            hyphens: "auto",
          }}
        >
          {game.actualTeams.guestTeamId ? (
            <TeamName variant="medium" teamId={game.actualTeams.guestTeamId} />
          ) : (
            <ResolvedTeamReference
              teamReference={game.plannedTeams.guest}
              competitionId={competitionId}
            />
          )}
        </div>
      </div>
    </div>
  );
};
